import { PaymentGatewayRef } from "../payment/PaymentGateway";
import { getProPricing } from '../../utils/pricingConfig';
import { useRef } from "react";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

import {
  FaBox,
  FaDesktop,
  FaChartLine,
  FaBullhorn,
  FaBuilding,
  FaFileAlt,
  FaFileInvoice,
  FaEllipsisH,
  FaTimes,
  FaUpload,
  FaCheck,
  FaInfoCircle,
  FaPlus,
  FaTrash,
  FaEdit,
  FaPaperclip,
} from "react-icons/fa";
import { Theme } from "../../lib/theme";
import { useNavigate } from "react-router-dom";
import { IpInfoResponse } from "../../types/authTypes";
import { Plan } from "../../types/pricingTypes";
import { PricingModal } from "../shared/PricingModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setUserPlan } from "../../redux/slices/userSlice";
import {
  setPptSlideCount,
  setPptTargetLanguage,
  setPptPresentationTone,
  setPptTargetAudience,
  setPptIncludeImages,
  setTechnicalDepth,
  resetToAuto,
} from "../../redux/slices/presentationOptionsSlice";
import {
  addTemplate,
  setCurrentTemplateId,
  setTemplates,
  setIsTemplateStateLoading
} from "../../redux/slices/templateSlice";
import uploadFileToS3 from "../../utils/uploadFileToS3";
import GuidedTour from "../onboarding/shared/GuidedTour";
import { useOutlineContext } from "../presentation-view/OutlineContext"; // Import Context API
import GuidedTourMobile from "../onboarding/shared/GuidedTourMobile";
import { Dialog } from "@headlessui/react";
import WebsiteLinkForm from "../onboarding/onboarding-sections/WebsiteLinkForm";
import { PricingModalGeneratePresentation } from "../shared/PricingModalGeneratePresentation";
import { setIsDiscounted } from '../../redux/slices/discountSlice'
import OfferModalNew from "../payment/offerModalNew";
import PaymentGateway from "../payment/PaymentGateway";
import { setRazorpayPlans, addRazorpayPlan } from '../../redux/slices/razorpayPlansSlice';
import { TrialBanner } from "../shared/TrialBanner";
import { useCredits } from '../../hooks/useCredits'
import { openPricing } from '../../utils/openPricing'
// Define an interface for colors
interface Colors {
  P100: string;
  P75_S25: string;
  P50_S50: string;
  P25_S75: string;
  S100: string;
  F_P100: string;
  F_P75_S25: string;
  F_P50_S50: string;
  F_P25_S75: string;
  F_S100: string;
  SCL: string;
  SCD: string;
}
const supportedLanguages = [
  "English",
  "Chinese (Simplified)",
  "Chinese (Traditional)",
  "Spanish",
  "French",
  "German",
  "Portuguese (Brazilian)",
  "Portuguese (European)",
  "Italian",
  "Russian",
  "Japanese",
  "Korean",
  "Dutch",
  "Arabic (Modern Standard)",
  "Polish",
  "Turkish",
  "Vietnamese",
];
interface SlideOutline {
  slideName?: any;
  title: string;
  type: string;
  keywords?: string;
  method?: string;
  outlineID: string;
}
const outlineTest: SlideOutline[] = [
  {
    title: "Introduction to Labor Movements",
    type: "Points",
    keywords: "Industrial revolution, Workers’ unions",
    outlineID: "outlineID-1a2b3c4d-1111-aaaa-2222-333344445555",
  },
  {
    title: "Early Struggles and Resistance",
    type: "Points",
    keywords: "Protests, Wage disputes, Exploitation",
    outlineID: "outlineID-2b3c4d5e-2222-bbbb-3333-444455556666",
  },
  {
    title: "Rise of Trade Unions",
    type: "Points",
    keywords: "Collective bargaining, Unionization",
    outlineID: "outlineID-3c4d5e6f-3333-cccc-4444-555566667777",
  },
  {
    title: "Legal Milestones in Labor Rights",
    type: "Points",
    keywords: "Labor laws, Minimum wage, Child labor bans",
    outlineID: "outlineID-4d5e6f70-4444-dddd-5555-666677778888",
  },
  {
    title: "Modern Challenges in the Workforce",
    type: "Points",
    keywords: "Gig economy, Job insecurity, Automation",
    outlineID: "outlineID-5e6f7081-5555-eeee-6666-777788889999",
  },
  {
    title: "Global Perspectives on Labor Reforms",
    type: "Points",
    keywords: "ILO, International standards, Developing nations",
    outlineID: "outlineID-6f708192-6666-ffff-7777-888899990000",
  },
  {
    title: "Conclusion and Future Outlook",
    type: "Points",
    keywords: "Sustainable labor, Equity, Digital rights",
    outlineID: "outlineID-7f8192a3-7777-aaaa-8888-999900001111",
  },
];

const SelectPresentationType: React.FC = () => {
  const presentationTypes = [
    { id: 1, label: "Product", icon: <FaBox className="text-[#3667B2]" /> },
    {
      id: 2,
      label: "Pitch Deck",
      icon: <FaDesktop className="text-[#3667B2]" />,
    },
    {
      id: 3,
      label: "Sales Deck",
      icon: <FaChartLine className="text-[#3667B2]" />,
    },
    {
      id: 4,
      label: "Marketing",
      icon: <FaBullhorn className="text-[#3667B2]" />,
    },
    {
      id: 5,
      label: "Company Overview",
      icon: <FaBuilding className="text-[#3667B2]" />,
    },
    {
      id: 6,
      label: "Project Proposal",
      icon: <FaFileInvoice className="text-[#3667B2]" />,
    },
    {
      id: 7,
      label: "Project Summary",
      icon: <FaFileAlt className="text-[#3667B2]" />,
    },
    {
      id: 8,
      label: "Others",
      icon: <FaEllipsisH className="text-[#3667B2]" />,
    },
  ];
  const [isRefineModalOpen, setIsRefineModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<string>("");
  const [templateUploading, setTemplateUploading] = useState(false);
  
  // Get template data from Redux
  const templateData = useSelector((state: any) => state.template);

  const handleColorChange = (
    key: keyof typeof brandingColors,
    color: string
  ): void => {
    setBrandingColors((prev) => ({ ...prev, [key]: color }));
  };
  const [file, setFile] = useState<File | null>(null);
  const userAgent = navigator.userAgent.toLowerCase();
  const { setIsOutlineGenerated } = useOutlineContext(); // ✅ Use Context API
  const [theme, setTheme] = useState("Light");
  const [creativity, setCreativity] = useState(5);
  const [pdfLink, setPdfLink] = useState("");
  const [pdfUploading, setPDFUploading] = useState(false);
  const [selectedType, setSelectedType] = useState<number | null>(null);
  const [customTypeInput, setCustomTypeInput] = useState<string>("");
  const navigate = useNavigate();
  const authToken = sessionStorage.getItem("authToken");
  const orgId = sessionStorage.getItem("orgId");
  const { credits, loading: creditsLoading, ensureCredits, deductOptimistic, setCredits, refresh } = useCredits()
  const MIN_PRESENTATION = 10
  const pricingModalHeading = "Refine PPT";
  const userPlan = useSelector((state: any) => state.user.userPlan);
  const [monthlyPlan, setMonthlyPlan] = useState<Plan>();
  const [yearlyPlan, setYearlyPlan] = useState<Plan>();
  const [currency, setCurrency] = useState("");
  const [subId, setSubId] = useState("");
  const dispatch = useDispatch();
  const [eligibleForGeneration, setEligibleForGeneration] = useState(false);
  const [showThemeTooltip, setShowThemeTooltip] = useState(false);
  const [hoveredTheme, setHoveredTheme] = useState<string | null>(null); // Track which theme is hovered
  const [pptCount, setPptCount] = useState(0);
  const [pptCountMonthly, setPptCountMonthly] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip1, setShowTooltip1] = useState(false);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const [showTooltip3, setShowTooltip3] = useState(false);
  const [showTooltip4, setShowTooltip4] = useState(false);
  const [showTooltip5, setShowTooltip5] = useState(false);
  const [websiteUrl, setWebsiteUrl] = useState<string>("");
  const [isHovered, setIsHovered] = useState(false);
  const [primaryColor, setPrimaryColor] = useState("#000000"); // Define the primary color
  const [textColor, setTextColor] = useState("#000000"); // Define the primary color
  const [secondaryColor, setSecondaryColor] = useState("#FFFFFF"); // Define the secondary color
  const [pptGenerateInput, setPptGenerateInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [outline, setOutline] = useState<SlideOutline[]>([]);
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);
  const [generatedDocumentIDoutline, setGeneratedDocumentIDoutline] = useState<
    string | null
  >(null);
  const [brandingColors, setBrandingColors] = useState<string[]>([]); // Initialize branding colors
  const [brandingColorsSave, setBrandingColorsSave] = useState<string[]>([]); // Initialize branding colors
  const [isLoading, setIsLoading] = useState<boolean>(false); // Add a loading state
  const [isValidLink, setIsValidLink] = useState(false);
  const [organizationColors, setOrganizationColors] = useState<Colors | null>(
    null
  );
  const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  const [language, setLanguage] = useState<string>("English");
  const [includeWebSearch, setIncludeWebSearch] = useState<boolean>(false);
  const [inputIndex, setInputIndex] = useState<number | null>(null);
  const [newOutline, setNewOutline] = useState<string>("");
  const [newOutlineLoading, setNewOutlineLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<"outline" | "options">("options");
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editedOutline, setEditedOutline] = useState<{
    title: string;
    keywords: string;
    slideInput:string;
  }>({ title: "", keywords: "" ,slideInput:""});

  const isTemplateStateLoading = useSelector((state: any) => state.template.isTemplateStateLoading);
  const templates = useSelector((state: any) => state.template.templates)
  const isDiscounted = useSelector((state: any) => state.discount.isDiscounted)
  const [isGeneratedData,setIsGeneratedData]=useState(false);
  
  // Trial tracking states
  const [trialEndDate, setTrialEndDate] = useState<string | null>(null);
  const [isOnTrial, setIsOnTrial] = useState<boolean>(false);
  const [hasUsedTrial, setHasUsedTrial] = useState<boolean>(false);
  const [checkingTrialEligibility, setCheckingTrialEligibility] = useState<boolean>(false);

  // Get presentation options from Redux
  const presentationOptions = useSelector((state: any) => state.presentationOptions);
  const {
    pptSlideCount,
    pptTargetLanguage,
    pptPresentationTone,
    pptTargetAudience,
    pptIncludeImages,
    technicalDepth,
  } = presentationOptions;

   const [pptReferenceWebUrl, setPptReferenceWebUrl] = useState<string>(""); // Default reference web URL
   const [pptTechnicalDepth, setPptTechnicalDepth] = useState<string>("Auto"); // Default technical depth
   const [pptIncludeCitations, setPptIncludeCitations] = useState<boolean>(true);
  // technicalDepth is now managed by Redux\
  const [isDiscountModalOpen,setIsDiscountModalOpne]=useState<boolean>(false);
  const paymentGatewayRef = useRef<PaymentGatewayRef>(null);
  const [documentID, setDocumentID] = useState<string | null>(null);
  const [offerGeneratedData,setOfferGeneratedData]=useState<boolean>(false);

  useEffect(() => {
  if (!authToken) {
    setEligibleForGeneration(true);
  } else {
    setEligibleForGeneration(false);
  }
}, [authToken]);

  const fetchOutlines = useCallback(async () => {
    if (!generatedDocumentIDoutline) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/${generatedDocumentIDoutline}/outline`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const { outline: fetchedOutlines } = response.data;

      setOutline(fetchedOutlines);
    } catch (error) {
      console.error("Error fetching outlines:", error);
    }
  }, [generatedDocumentIDoutline, authToken]);

  const handleAddOutline = async (index: number) => {
    const newOutlineID = generateOutlineID();

    setNewOutlineLoading(true);
    if (!newOutline.trim()) {
      console.log("New outline is empty");
      setNewOutlineLoading(false);
      return;
    }
    const updatedOutline = { title: newOutline };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/insert`,
        {
          documentId: generatedDocumentIDoutline,
          title: updatedOutline.title,
          position: index + 1,
          outlineID: newOutlineID,
          websiteUrl:websiteUrl
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const result = response.data;
      if (result.title && result.type) {
        // Retrieve the existing outlineIDs array from sessionStorage
        const storedOutlineIDs = sessionStorage.getItem("outlineIDs");
        let outlineIDs = storedOutlineIDs ? JSON.parse(storedOutlineIDs) : [];

        // Add the new outlineID to the array
        outlineIDs.push(newOutlineID);

        // Save the updated array back to sessionStorage
        sessionStorage.setItem("outlineIDs", JSON.stringify(outlineIDs));
        toast.success("Outline Successfully Added", {
          position: "top-right",
          autoClose: 3000,
        });
        fetchOutlines();
        setNewOutlineLoading(false);
      }
      setInputIndex(null);
      setNewOutline("");
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        toast.error("Upgrade to add more slides", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        toast.error("Error adding outline", {
          position: "top-right",
          autoClose: 3000,
        });
      }
      console.error("Error adding outline:", error);
      setNewOutlineLoading(false);
    }
  };

  const handleDeleteOutline = async (index: number) => {
    if (!generatedDocumentIDoutline) return;

    setOutline((prevOutlines) => {
      const updatedOutlines = [...prevOutlines];
      const deletedItem = updatedOutlines.splice(index, 1);

      (async () => {
        try {
          await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/delete`,
            {
              documentId: generatedDocumentIDoutline,
              index,
            },
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
          toast.success("Outline deleted successfully", {
            position: "top-right",
            autoClose: 3000,
          });
        } catch (error) {
          // Rollback on failure
          setOutline((current) => {
            const rollbackOutlines = [...current];
            rollbackOutlines.splice(index, 0, deletedItem[0]);
            return rollbackOutlines;
          });

          toast.error("Failed to delete outline. Please try again.", {
            position: "top-right",
            autoClose: 3000,
          });

          console.error("Error deleting outline:", error);
        }
      })();

      return updatedOutlines;
    });
  };

  const handleCloseModal = () => {
    setGeneratedDocumentIDoutline(null); // Reset ID when closing
    setIsRefineModalOpen(false);
    setIsOutlineReviewed(false);
    setActiveTab("options");
  };
  const generateOutlineID = () => {
    return `outlineID-${window.crypto.randomUUID()}`;
  };
  useEffect(() => {
    if (websiteUrl) {
      setIsValidLink(urlRegex.test(websiteUrl));
    }
  }, [websiteUrl]); // Re-run validation when `websiteUrl` changes

  const generateDocumentID = () => {
    return "Document-" + Date.now();
  };
  const generatedDocumentID = generateDocumentID();

  const MAX_FILE_SIZE_MB = 20; // Limit file size to 20MB

  const generateTemplateId = () => {
    return "template-" + Date.now() + "-" + Math.random().toString(36).substr(2, 9);
  };

  const handleTemplateUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTemplateUploading(true);

    if (event.target.files && event.target.files[0]) {
      const uploadedFile = event.target.files[0];

      // Check for duplicate template names
      const isDuplicate = templates?.some(
        (template: { templateName: string }) =>
          template.templateName === uploadedFile.name
      );
      if (isDuplicate) {
        toast.error("A template with this name already exists. Please rename the file or choose a different template.", {
          position: "top-right",
          autoClose: 3000,
        });
        setTemplateUploading(false);
        return;
      }

      // Check file size
      const fileSizeMB = uploadedFile.size / (1024 * 1024);
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        toast.error(
          `File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload a smaller file.`,
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        setTemplateUploading(false);
        return;
      }

      try {
        const templateFile = {
          name: uploadedFile.name,
          type: uploadedFile.type,
          body: uploadedFile,
        };
        
        // Upload to S3
        const templateUrl = await uploadFileToS3(templateFile, true);
        const templateId = generateTemplateId();
        const templateName = uploadedFile.name;
        
        // Update Redux
        dispatch(addTemplate({ templateName, templateUrl, templateId, status: "processing" }));
        // dispatch(setCurrentTemplateId(templateId));
        
        // Update organization profile with processing status
        const newTemplate = {templateName, templateUrl, templateId, status: "processing" };
        const updatedTemplates = [...(templates || []), newTemplate];
        
        await axios.patch(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
          {
            templates: updatedTemplates
          },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        
        // Update Redux with the complete templates array
        dispatch(setTemplates(updatedTemplates));
        
        toast.success("Template uploaded successfully ,processing will take 2-3 minutes!", {
          position: "top-right",
          autoClose: 3000,
        });
        
        setTemplateUploading(false);
        
        // First API call - Extract PPT (after success toast)
        const extractResponse = await axios.post(
          `https://d3u5xpqekkh4uv.cloudfront.net/api/extract-ppt?s3_key=${templateUrl}&upload_images_to_s3=true&template_id=${templateId}&save_to_sheets=yes`
        );
        
        console.log('Extract PPT Response:', extractResponse.data);
        
        // Second API call - Classification (using response from first call)
        if (extractResponse.data.success) {
          const classificationResponse = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/classification`,
            {
              sheetUrl: "https://docs.google.com/spreadsheets/d/12F312EN5svGtdMWASyhpmAJeGhe-OIazVZkyFMEwy_I/edit?gid=0#gid=0",
              templateId: templateId,
              orgId: orgId,
              pptUrl: extractResponse.data.excel_s3_url
            },
           {
              headers: {
              "Content-Type": "application/json"
            },
            }
          );
          
          console.log('Classification Response:', classificationResponse.data);
          
          // Fetch updated templates after classification completes
          const updatedOrgResponse = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
          dispatch(setTemplates(updatedOrgResponse.data.templates || []));
        }
        
        
        
      } catch (error) {
        console.error("Error uploading template:", error);
        toast.error("Failed to upload/process template. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
        // setProcessingTemplateId(null);
      } finally {
        setTemplateUploading(false);
      }
    } else {
      setTemplateUploading(false);
    }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPDFUploading(true);

    if (event.target.files && event.target.files[0]) {
      const uploadedFile = event.target.files[0];

      // Check file size
      const fileSizeMB = uploadedFile.size / (1024 * 1024);
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        toast.error(
          `File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload a smaller file.`,
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        setPDFUploading(false);
        return;
      }

      setFile(uploadedFile);

      try {
        const pdfUploaded = {
          name: uploadedFile.name,
          type: uploadedFile.type,
          body: uploadedFile, // Pass the File object directly
        };
        // Handle upload
        const pdfLink = await uploadFileToS3(pdfUploaded);
        setPdfLink(pdfLink);
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error("Failed to upload file. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
      } finally {
        setPDFUploading(false);
      }
    } else {
      setPDFUploading(false);
    }
  };

  const handleGenerate = async () => {
    // Pre-flight credit check: if credits are loading, ask user to wait;
    // if insufficient, open canonical pricing page in a new tab and DO NOT proceed.
    if (creditsLoading) {
      toast.info("Checking credits, please wait...", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    if (!ensureCredits(MIN_PRESENTATION)) {
      // open pricing in a new tab with context params
      openPricing("selectpresentation");
      return; // important: prevent navigation/generation when credits insufficient
    }

    // Optimistically deduct credits so the header updates immediately.
    const prevCredits = credits ?? 0;
    try {
      deductOptimistic(MIN_PRESENTATION);
      try { localStorage.setItem('zynth:credits_updated', String(Date.now())); } catch (e) {}
    } catch (e) {
      // ignore
    }

    navigate(`/presentation-view?documentID=${generatedDocumentIDoutline}`);

    const quickGenerate = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/${orgId}/${generatedDocumentIDoutline}`,
          {
            pptInput: pptGenerateInput,
          },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        await response.data;
      } catch (error: any) {
        // Rollback optimistic deduction on failure
        try { setCredits(prevCredits); localStorage.setItem('zynth:credits_updated', String(Date.now())); } catch (e) {}
        if (error.response?.status === 404) {
          toast.error("Error generating ppt", {
            position: "top-right",
            autoClose: 3000,
          });
        }
        if (error.response?.status === 402) {
          openPricing('selectpresentation_credit')
        }
      }
    };

    const updatePptCount = async () => {
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        {
          pptcount: pptCount + 1,
          pptcount_monthly: pptCountMonthly + 1,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
    };

    await quickGenerate();
    await updatePptCount();
    // Refresh credits from server to reflect authoritative state
    try { await refresh(); } catch (e) {}
  };
  const handleSaveColors = async () => {
    setIsLoading(true); // Show loading state

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile//organization/updateColors/${orgId}`,
        { primaryColor, secondaryColor },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      if (response.status === 200) {
        const colors = response.data.colors || organizationColors;

        // ✅ Build a colorMap with safe defaults
        const colorMap = {
          P100: colors.P100 || "#17191A",
          P75_S25: colors.P75_S25 || "#313B48",
          P50_S50: colors.P50_S50 || "#4A5C75",
          P25_S75: colors.P25_S75 || "#647EA3",
          S100: colors.S100 || "#7D9FD0",
          F_P100: colors.F_P100 || "#E8E8E8",
          F_P75_S25: colors.F_P75_S25 || "#E4E8EC",
          F_P50_S50: colors.F_P50_S50 || "#FFFFFF",
          F_P25_S75: colors.F_P25_S75 || "#FFFFFF",
          F_S100: colors.F_S100 || "#FFFFFF",
          SCL: colors.SCL || "#FFFFFF",
          SCD: colors.SCD || "#000000",
        };

        // Convert object values into arrays
        const colorArray: string[] = [
          colorMap.P100,
          colorMap.P75_S25,
          colorMap.P50_S50,
          colorMap.P25_S75,
          colorMap.S100,
        ];

        const colorArraySave: string[] = [
          colorMap.P100,
          colorMap.P75_S25,
          colorMap.P50_S50,
          colorMap.P25_S75,
          colorMap.S100,
          colorMap.F_P100,
          colorMap.F_P75_S25,
          colorMap.F_P50_S50,
          colorMap.F_P25_S75,
          colorMap.F_S100,
          colorMap.SCL,
          colorMap.SCD,
        ];

        await setBrandingColors([...colorArray]);
        await setBrandingColorsSave([...colorArraySave]);

        // ✅ Set individual color states
        setPrimaryColor(colorMap.P100);
        setTextColor(colorMap.F_P100);
        setSecondaryColor(colorMap.S100);
      }
    } catch (error) {
      console.error("Error updating branding colors:", error);
    } finally {
      setIsLoading(false); // Hide loading state
    }
  };

  // const handleRefinePPT = () => {
  //   const refinePPT = async () => {
  //     if (!file) {
  //       toast.info('Please upload a PDF to refine', {
  //         position: 'top-right',
  //         autoClose: 3000,
  //       })
  //       return
  //     }

  //     navigate(
  //       `/presentation-view?documentID=${generatedDocumentIDoutline}`
  //     )

  //     try {
  //       const response = await axios.post(
  //         `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/refineppt/${orgId}/${generatedDocumentIDoutline}`,
  //         {
  //           pdfLink: pdfLink,
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authToken}`,
  //           },
  //         }
  //       )

  //       await response.data
  //     } catch (error: any) {

  //     }
  //   }

  //   const updatePptCount = async () => {
  //     await axios.patch(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
  //       {
  //         pptcount: pptCount + 1,
  //         pptcount_monthly: pptCountMonthly + 1,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     )
  //   }
  //   refinePPT()
  //   updatePptCount()
  // }

  const updatePptCount = useCallback(async () => {
    await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
      {
        pptcount: pptCount + 1,
        pptcount_monthly: pptCountMonthly + 1,
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
  }, [orgId, pptCount, pptCountMonthly, authToken]);
  const isButtonDisabled =
    selectedType === 8
      ? !customTypeInput.trim() ||
        (userPlan !== "pro" && !eligibleForGeneration)
      : !selectedType || (userPlan !== "pro" && !eligibleForGeneration);

  // API CALL TO GET PRICING DATA FOR MODAL AND USER PLAN
  useEffect(() => {
    const getPricingData = async () => {
      const ipInfoResponse = await fetch("https://api.zynth.ai/api/v1/data/userprofile/ip-info");
      const ipInfoData: IpInfoResponse = await ipInfoResponse.json();

      await axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/appscripts/razorpay/plans`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        .then((response) => {
          const country = ipInfoData!.country!;
          dispatch(setRazorpayPlans(response.data.items))
          if (country !== "IN" && country !== "India" && country !== "In") {
            if(isDiscounted){
            setMonthlyPlan(response.data.items[1]);
            setYearlyPlan(response.data.items[3]);
            }
            else{
           setMonthlyPlan(response.data.items[5]);
            setYearlyPlan(response.data.items[6]);
            }
            // setMonthlyPlan(response.data.items[1])
            // setYearlyPlan(response.data.items[0])
            setCurrency("USD");
          } else if (
            country === "IN" ||
            country === "India" ||
            country === "In"
          ) {
             if(isDiscounted){
            setMonthlyPlan(response.data.items[2]);
            setYearlyPlan(response.data.items[4]);
            }
            setMonthlyPlan(response.data.items[8]);
            setYearlyPlan(response.data.items[7]);
            // setMonthlyPlan(response.data.items[1])handle
            // setYearlyPlan(response.data.items[0])
            setCurrency("INR");
          }
        });
    };

    const fetchUserPlan = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        const planName = response.data.plan.plan_name;
        const subscriptionId = response.data.plan.subscriptionId;
        
        setPptCount(response.data.pptcount);
        setPptCountMonthly(response.data.pptcount_monthly);
        if (planName.toLowerCase() !== "free" || response.data.is_eligible === true) {
          setEligibleForGeneration(true);
        } else {
          setEligibleForGeneration(false);
        }
        dispatch(setUserPlan(planName));
        dispatch(setTemplates(response.data.templates || []));
        console.log('Templates loaded from API:', response.data.templates); // Debug log
        setSubId(subscriptionId);
        
        // Check for trial information
        if (response.data.trial_end_date) {
          setTrialEndDate(response.data.trial_end_date);
          setIsOnTrial(true);
          console.log('🎯 Trial Active - End Date:', response.data.trial_end_date);
        } else {
          setTrialEndDate(null);
          setIsOnTrial(false);
        }
      } catch (error) {
        console.error("Error fetching user plan:", error);
      }
    };

    fetchUserPlan();
    getPricingData();
  }, []);
  
  // Check sessionStorage for trial info on mount (for immediate display after trial start)
  useEffect(() => {
    const storedTrialEndDate = sessionStorage.getItem('trialEndDate');
    if (storedTrialEndDate && !trialEndDate) {
      setTrialEndDate(storedTrialEndDate);
      setIsOnTrial(true);
      console.log('📦 Trial info loaded from sessionStorage:', storedTrialEndDate);
    }
  }, []);
  
  const monthlyPlanAmount = monthlyPlan?.item.amount! / 100;
  const monthlyPlanId = monthlyPlan?.id;
  const yearlyPlanAmount = yearlyPlan?.item.amount! / 100;
  const yearlyPlanId = yearlyPlan?.id;
  const Tooltip: React.FC<{ message: string }> = ({ message }) => {
    return (
      <div className="absolute left-8 bottom-10 w-72 bg-gray-800 text-white text-sm rounded-lg px-4 py-2 shadow-lg">
        {message}
      </div>
    );
  };
  const [visibleTooltip, setVisibleTooltip] = useState<string | null>(null);
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (!isHovered && visibleTooltip === "generate") {
      timeout = setTimeout(() => {
        setVisibleTooltip(null);
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [isHovered, visibleTooltip]);
  const [isOutlineReviewed, setIsOutlineReviewed] = useState<boolean>(false);
  const [isOutlineLoading, setIsOutlineLoading] = useState<boolean>(false);
  const [documentName, setDocumentName] = useState<string>("");
  const getActualValue = (value: string, defaultValue: string) => {
      return value === "Auto" ? defaultValue : value;
    };
  const generateOutline = useCallback(async () => {
    setLoading(true);
    setIsOutlineLoading(true);

    let docID = generatedDocumentIDoutline || generateDocumentID();
    setGeneratedDocumentIDoutline(docID);

    // Map Auto values to defaults
    

    const currentTemplateId = templateData.currentTemplateId;
    const selectedTemplateData = templates?.find(
      (t: { templateId: string }) => t.templateId === currentTemplateId
    );
    
    const payload = {
      pptInput: pptGenerateInput || "",
      pdfLink: pdfLink || "",
      deviceType: userAgent,
      slideCount: getActualValue(presentationOptions.pptSlideCount, "5 to 10 slides"),
      language: getActualValue(presentationOptions.pptTargetLanguage, "English"),
      tone: getActualValue(presentationOptions.pptPresentationTone, "Professional"),
      audience: getActualValue(presentationOptions.pptTargetAudience, "General Audience"),
      images: presentationOptions.pptIncludeImages,
      sourceOrcas:false,
      ...(currentTemplateId && selectedTemplateData && {
        templateId: currentTemplateId,
      })
    };
    
    console.log(payload)
    try {
      const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/outline/${orgId}/${docID}`;

      const response = await axios.post(requestUrl, payload, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (response.status !== 200)
        throw new Error("Failed to generate outline");

      setOutline(response.data.outline);
      setDocumentName(response.data.documentName);

      // ✅ Notify other components via Context API
      setIsOutlineGenerated(true);

      console.log("Outline generated successfully:", response.data.outline);
      setIsOutlineLoading(false);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("API Error:", error.response?.data || error.message);
      } else {
        console.error("Unexpected Error:", error);
      }
      setIsOutlineLoading(false);
    } finally {
      setLoading(false);
      console.log("Device Type:", userAgent);
      setIsOutlineLoading(false);
    }
  }, [generatedDocumentIDoutline, pptGenerateInput, pdfLink, userAgent, orgId, authToken, setIsOutlineGenerated, presentationOptions]);

  const generateDocument = async () => {
    setLoading(true);
    dispatch(setIsTemplateStateLoading(true));
   
    navigate(`/presentation-view?documentID=${generatedDocumentIDoutline}`);
    if (!generatedDocumentIDoutline) {
      console.error("Error: Presentation ID is missing. Generate outline first.");
      setLoading(false);
      return;
    }
    const colorsToUse = brandingColorsSave.length
      ? brandingColorsSave
      : Object.values(organizationColors || {});

    const colorKeys = [
      "P100",
      "P75_S25",
      "P50_S50",
      "P25_S75",
      "S100",
      "F_P100",
      "F_P75_S25",
      "F_P50_S50",
      "F_P25_S75",
      "F_S100",
      "SCL",
      "SCD",
    ];

    const currentTemplateId = templateData.currentTemplateId;
    const selectedTemplateData = templates?.find(
      (t: { templateId: string }) => t.templateId === currentTemplateId
    );
    
    const payload = {
      websiteUrl: websiteUrl || "",
      colors: colorKeys.reduce((acc: { [key: string]: string }, key, index) => {
        acc[key] = colorsToUse[index] || "#000000"; // Default to black if missing
        return acc;
      }, {} as { [key: string]: string }),
      creativity: creativity, // Number
      theme: theme, // String
      webSearchToogle: includeWebSearch,
      language: getActualValue(presentationOptions.pptTargetLanguage, "English"),
      technicaldepth: presentationOptions.technicalDepth=="Auto"?"Medium":presentationOptions.technicalDepth,
      ...(currentTemplateId && selectedTemplateData && {
        templateId: currentTemplateId,
        templateUrl: selectedTemplateData.templateUrl
      })
    };

    // Preserve previous credits for potential rollback
    const prevCredits = credits ?? 0;
    try {
      // Optimistically deduct credits for immediate UI feedback
      try {
        deductOptimistic(MIN_PRESENTATION);
        try { localStorage.setItem('zynth:credits_updated', String(Date.now())); } catch (e) {}
      } catch (e) {}

      const requestUrl = currentTemplateId && selectedTemplateData 
        ? `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-template/${orgId}/${generatedDocumentIDoutline}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/${orgId}/${generatedDocumentIDoutline}`;

      console.log("Presentation Request URL:", requestUrl);
      console.log("Payload:", payload);

      const response = await axios.post(requestUrl, payload, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status !== 200)
        throw new Error("Failed to generate presentation");

      const data = response.data;
      setOutline(data.outline);
      await updatePptCount();

      // refresh authoritative credits
      try { await refresh(); } catch (e) {}
    } catch (error: any) {
      // rollback optimistic deduction
      try { setCredits(prevCredits); localStorage.setItem('zynth:credits_updated', String(Date.now())); } catch (e) {}
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 402) {
          openPricing('selectpresentation_credit')
        }
      }
    } finally {
      setLoading(false);
      dispatch(setIsTemplateStateLoading(false));
    }
  };

  const getWebsiteData= async () => {
    try{
      const payload = {
        websiteUrl: websiteUrl || "",
        webSearchToogle:includeWebSearch || false,
      }
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/get-website-data/${orgId}/${generatedDocumentIDoutline}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
        if (res.status !== 200)
        throw new Error("Failed to generate presentation");

      const data = res.data;
    }
    catch(error){
      console.error("Error fetching website data:", error);
    }
  };


  const handleButtonClick = async () => {
    try {
      const documentID = await generateDocument(); // Wait for completion
    } catch (error) {
      console.error("Error generating presentation:", error);
    }
  };

  const fetchOrganizationData = async () => {
    if (!orgId) {
      console.error("Error: Organization ID is missing.");
      return;
    }

    setLoading(true);
    const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`;

    try {
      console.log("Fetching Organization Data:", requestUrl);

      const response = await axios.get(requestUrl, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (response.status !== 200) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }

      const data = response.data;
      console.log("Fetched Organization Data:", data);

      setWebsiteUrl(data.websiteLink || "");
      
      // Set trial status
      setHasUsedTrial(data.hasUsedTrial || false);
      console.log("📊 Has Used Trial:", data.hasUsedTrial);

      // Ensure colors exist before processing
      if (data.color && typeof data.color === "object") {
        const colorMap = {
          P100: data.color.P100 || "#17191A",
          P75_S25: data.color.P75_S25 || "#313B48",
          P50_S50: data.color.P50_S50 || "#4A5C75",
          P25_S75: data.color.P25_S75 || "#647EA3",
          S100: data.color.S100 || "#7D9FD0",
          F_P100: data.color.F_P100 || "#E8E8E8",
          F_P75_S25: data.color.F_P75_S25 || "#E4E8EC",
          F_P50_S50: data.color.F_P50_S50 || "#FFFFFF",
          F_P25_S75: data.color.F_P25_S75 || "#FFFFFF",
          F_S100: data.color.F_S100 || "#FFFFFF",
          SCL: data.color.SCL || "#FFFFFF",
          SCD: data.color.SCD || "#000000",
        };

        setBrandingColors([
          colorMap.P100,
          colorMap.P75_S25,
          colorMap.P50_S50,
          colorMap.P25_S75,
          colorMap.S100,
        ]);

        setOrganizationColors(colorMap);
        setPrimaryColor(colorMap.P100);
        setTextColor(colorMap.F_P100);
        setSecondaryColor(colorMap.S100);
      }
    } catch (error) {
      if (error instanceof Error) {
        console.error("Error fetching organization data:", error.message);
      } else {
        console.error("Error fetching organization data:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizationData();
  }, [orgId, authToken]);
  // useEffect(() => {
  //   const fetchOrganizationData = async () => {
  //     if (!orgId) {
  //       console.error("Error: Organization ID is missing.");
  //       return;
  //     }

  //     setLoading(true);
  //     const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`;

  //     try {
  //       console.log("Fetching Organization Data:", requestUrl);

  //       const response = await axios.get(requestUrl, {
  //         headers: { Authorization: `Bearer ${authToken}` },
  //       });

  //       if (response.status !== 200) {
  //         throw new Error(`Failed to fetch data: ${response.statusText}`);
  //       }

  //       const data = response.data;
  //       console.log("Fetched Organization Data:", data);

  //       setWebsiteUrl(data.websiteLink || "");

  //       // Ensure colors exist before processing
  //       if (data.color && typeof data.color === "object") {
  //         const colorMap = {
  //           P100: data.color.P100 || "#000000",
  //           P75_S25: data.color.P75_S25 || "#290000",
  //           P50_S50: data.color.P50_S50 || "#520000",
  //           P25_S75: data.color.P25_S75 || "#7A0000",
  //           S100: data.color.S100 || "#a30000",
  //           F_P100: data.color.F_P100 || "#FFFFFF",
  //           F_P75_S25: data.color.F_P75_S25 || "#FFFFFF",
  //           F_P50_S50: data.color.F_P50_S50 || "#FFFFFF",
  //           F_P25_S75: data.color.F_P25_S75 || "#E9E9E9",
  //           F_S100: data.color.F_S100 || "#EADFF2",
  //           SCL: data.color.SCL || "#FFFFFF",
  //           SCD: data.color.SCD || "#000000",
  //         };

  //         setBrandingColors([
  //           colorMap.P100,
  //           colorMap.P75_S25,
  //           colorMap.P50_S50,
  //           colorMap.P25_S75,
  //           colorMap.S100,
  //         ]);

  //         setOrganizationColors(colorMap);
  //         setPrimaryColor(colorMap.P100);
  //         setTextColor(colorMap.F_P100);
  //         setSecondaryColor(colorMap.S100);
  //       }
  //     } catch (error) {
  //       if (error instanceof Error) {
  //         console.error("Error fetching organization data:", error.message);
  //       } else {
  //         console.error("Error fetching organization data:", error);
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchOrganizationData();
  // }, [orgId, authToken]);
    useEffect(() => {
      const storedInput = sessionStorage.getItem("pptPendingGenerateInput");
      const storedPdfLink = sessionStorage.getItem("pendingPdfLink");
      const storedFileName = sessionStorage.getItem("pendingFileName");
      const storedFileType = sessionStorage.getItem("pendingFileType");
      const autoSubmitAfterAuth = sessionStorage.getItem("autoSubmitAfterAuth");
      const autoOpenModalAfterAuth = sessionStorage.getItem(
        "autoOpenModalAfterAuth"
      );
      // Retrieve stored presentation options
      const storedWordLength = sessionStorage.getItem("pptPendingWordLength");
      const storedIncludeImages = sessionStorage.getItem("pptPendingIncludeImages");
      const storedTargetLanguage = sessionStorage.getItem(
        "pptPendingTargetLanguage"
      );
      const storedPresentationTone = sessionStorage.getItem(
        "pptPendingPresentationTone"
      );
      const storedTargetAudience = sessionStorage.getItem(
        "pptPendingTargetAudience"
      );
  
      // Retrieve stored inner modal presentation options
      const storedReferenceWebUrl = sessionStorage.getItem(
        "pptPendingReferenceWebUrl"
      );
      const storedIncludeWebSearch = sessionStorage.getItem(
        "pptPendingIncludeWebSearch"
      );
      const storedTechnicalDepth = sessionStorage.getItem(
        "pptPendingTechnicalDepth"
      );
      const storedIncludeCitations = sessionStorage.getItem(
        "pptPendingIncludeCitations"
      );
  
      // If we have auth token and stored data, it means user has just logged in
      if (authToken && (storedInput || storedPdfLink)) {
        // Restore all prefill data
        if (storedInput) setPptGenerateInput(storedInput);
        if (storedPdfLink) {
          setPdfLink(storedPdfLink);
          if (storedFileName && storedFileType) {
            const placeholderFile = new File([""], storedFileName, {
              type: storedFileType,
            });
            setFile(placeholderFile);
          }
        }
        if (storedWordLength) dispatch(setPptSlideCount(storedWordLength));
        if (storedIncludeImages) dispatch(setPptIncludeImages(storedIncludeImages === "true"));
        if (storedTargetLanguage) dispatch(setPptTargetLanguage(storedTargetLanguage));
        if (storedPresentationTone) dispatch(setPptPresentationTone(storedPresentationTone));
        if (storedTargetAudience) dispatch(setPptTargetAudience(storedTargetAudience));
        if (storedReferenceWebUrl) setPptReferenceWebUrl(storedReferenceWebUrl);
        if (storedIncludeWebSearch)
          setIncludeWebSearch(storedIncludeWebSearch === "true");
        // if (storedTechnicalDepth) setPptTechnicalDepth(storedTechnicalDepth);
        if (storedIncludeCitations)
          setPptIncludeCitations(storedIncludeCitations === "true");
  
        // Clear stored data after using it
        sessionStorage.removeItem("pptPendingGenerateInput");
        sessionStorage.removeItem("pendingPdfLink");
        sessionStorage.removeItem("pendingFileName");
        sessionStorage.removeItem("pendingFileType");
        sessionStorage.removeItem("autoSubmitAfterAuth");
        sessionStorage.removeItem("pptPendingWordLength");
        sessionStorage.removeItem("pptPendingIncludeImages");
        sessionStorage.removeItem("pptPendingTargetLanguage");
        sessionStorage.removeItem("pptPendingPresentationTone");
        sessionStorage.removeItem("pptPendingTargetAudience");
        sessionStorage.removeItem("pptPendingReferenceWebUrl");
        sessionStorage.removeItem("pptPendingIncludeWebSearch");
        sessionStorage.removeItem("pptPendingTechnicalDepth");
        sessionStorage.removeItem("pptPendingIncludeCitations");
  
       
  
        // Show success message and auto-generate outline after login
        if (autoSubmitAfterAuth === "true") {
          toast.success("Successfully logged in! Your data has been restored.", {
            position: "top-right",
            autoClose: 3000,
          });
          sessionStorage.removeItem("autoOpenModalAfterAuth");
          
          // Auto-generate outline after login
        
          
          // Small delay to ensure state is updated
        }
      }
    }, [authToken]);
  
    const [showCreativityTooltip, setShowCreativityTooltip] = useState(false);
    const [displayedTitle, setDisplayedTitle] = useState("");
    const fullTitle =
      "Describe the presentation you want to build.";
      useEffect(() => {
        let index = 0;
        const timer = setInterval(() => {
          if (index < fullTitle.length) {
            setDisplayedTitle(fullTitle.slice(0, index + 1));
            index++;
          } else {
            clearInterval(timer);
          }
        }, 50);
    
        return () => clearInterval(timer);
      }, []);
    
      const handleGeneratePresentation = () => {
    setIsRefineModalOpen(true);
    generateOutline();
    updatePptCount();
  }

  const isLoggedIn = !!authToken;

  return (
    <div
          className={`relative flex p-2 flex-col items-center justify-start pt-2 min-h-[80vh]  sm:min-h-[85vh]   md:min-h-[90vh]    xl:min-h-screen w-full ${!isLoggedIn ? 'pb-32 sm:pb-40' : ''}`}
          style={{
            backgroundColor: Theme.colors.background,
          }}
        >
          {/* Trial Banner - Show at the top if user is on trial */}
          {isOnTrial && trialEndDate && (
            <div className="w-full max-w-4xl mx-auto px-4 pt-4">
              <TrialBanner 
                trialEndDate={trialEndDate}
                onDismiss={() => setIsOnTrial(false)}
              />
            </div>
          )}
          
          <div
            className={`relative w-full text-center flex flex-col items-center justify-start h-[80vh]    xl:h-[60vh]       ${
              isLoggedIn ? "" : ""
            }`}
            // style={{
            //   minHeight: "100vh",
            // }}
          >
            {/* Dot Pattern Background */}
            <div
              className="absolute inset-0 w-full h-full opacity-50"
              style={{
                backgroundImage: `radial-gradient(circle, #d1d5db 1px, transparent 1px)`,
                backgroundSize: "20px 20px",
                backgroundPosition: "0 0, 10px 10px",
              }}
            />
            <div className="absolute inset-0 z-[-1] rounded-3xl"></div>
    
            {/* Title */}
            <h2
              className={`text-2xl md:text-3xl lg:text-4xl font-bold mb-2 md:mb-4 leading-tight text-gray-90 mt-2 md:mt-4 lg:mt-6 2xl:mt-10`}
            >
              {displayedTitle}
              <span className="cursor-pulse">|</span>
            </h2>
    
            {/* <h2
        className="text-2xl font-semibold mb-6 text-gray-700"
        style={{ color: Theme.colors.text.strong }}
      >
        Tell us what you want to build
      </h2> */}
    
            <p
              className="flex items-center gap-1 relative text-base md:text-lg mb-3 md:mb-4 mt-2 md:mt-3 lg:mt-6 xl:mt-8"
              style={{ color: Theme.colors.text.weak }}
            >
              Enter your presentation context.
              <span
                className="cursor-pointer relative ml-2"
                style={{ color: Theme.colors.primary }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <FaInfoCircle className="cursor-pointer relative" />
    
                {/* Desktop tooltip */}
                {showTooltip && (
                  <div
                    className="absolute z-50 hidden lg:block left-full ml-2 transform -translate-y-1/2 w-72 p-4 text-xs rounded-2xl shadow-lg opacity-100 transition-opacity duration-300 text-left"
                    style={{
                      backgroundColor: Theme.colors.grounding,
                      color: Theme.colors.background,
                    }}
                  >
                    <p className="font-semibold mb-2">
                      Provide clear details about your presentation requirements.
                      The more specific you are, the more relevant the output will
                      be.
                    </p>
                    <p>
                      - Outline the objective and key message of the presentation.
                    </p>
                    <p>
                      - Specify any required slides, information, or data to
                      include.
                    </p>
                    <p>
                      - Provide detailed instructions to ensure alignment with your
                      vision.
                    </p>
                  </div>
                )}
    
                {/* Mobile tooltip */}
                {showTooltip && (
                  <div
                    className="absolute z-50 top-0 lg:hidden left-[80%] -translate-x-[80%] -translate-y-[80%] w-72 p-4 text-xs rounded-2xl shadow-lg opacity-100 transition-opacity duration-300 text-left"
                    style={{
                      backgroundColor: Theme.colors.grounding,
                      color: Theme.colors.background,
                    }}
                  >
                    <p className="font-semibold mb-2">
                      Provide clear details about your presentation requirements.
                      The more specific you are, the more relevant the output will
                      be.
                    </p>
                    <p>
                      - Outline the objective and key message of the presentation.
                    </p>
                    <p>
                      - Specify any required slides, information, or data to
                      include.
                    </p>
                    <p>
                      - Provide detailed instructions to ensure alignment with your
                      vision.
                    </p>
                  </div>
                )}
              </span>
            </p>
    
            {/* Textarea card with toolbar */}
            <div className="relative  w-full flex justify-center">
              <div
                className="lg:w-2/3 w-[92%] mx-auto rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition"
                style={{
                  border: `1px solid ${Theme.colors.stroke.weak}`,
                  backgroundColor: Theme.colors.background,
                }}
              >
                <textarea
                  className="w-full h-[7.5rem] p-6 resize-none bg-transparent outline-none text-gray-800"
                  style={{
                    fontFamily: Theme.font.family,
                  }}
                  placeholder="Add text or drop content here — more details mean a more tailored presentation!"
                  value={pptGenerateInput || ""}
                  onChange={(e) => setPptGenerateInput(e.target.value)}
                  minLength={file ? 0 : 100}
                  maxLength={10000}
                />
    
                {/* Toolbar */}
                <div
                  className="flex flex-col min-[380px]:flex-row min-[380px]:items-center min-[380px]:justify-between px-5 py-3 bg-gray-50 gap-3 min-[380px]:gap-0"
                  style={{ borderTop: `1px solid ${Theme.colors.stroke.weak}` }}
                >
                  <div className="flex items-center gap-3 min-[380px]:gap-6 flex-wrap min-[380px]:flex-nowrap">
                    <label className="cursor-pointer flex items-center gap-1 min-[380px]:gap-2 text-sm min-[380px]:text-base font-medium text-blue-600 hover:text-blue-700 min-w-0">
                      {pdfUploading ? (
                        <span className="text-gray-700 text-sm">Uploading...</span>
                      ) : file ? (
                        <>
                          <button
                            type="button"
                            className="text-gray-500 hover:text-red-500 flex-shrink-0"
                            onClick={(e) => {
                              e.preventDefault();
                              setFile(null);
                              setPdfLink("");
                            }}
                          >
                            <FaTimes className="text-sm" />
                          </button>
                          <span className="truncate max-w-[80px] min-[380px]:max-w-[120px] sm:max-w-[150px] md:max-w-[200px] text-sm min-[380px]:text-base">
                            {file.name}
                          </span>
                        </>
                      ) : (
                        <>
                          <FaPaperclip className="text-sm min-[380px]:text-lg flex-shrink-0" />
                          <span className="text-sm min-[380px]:text-base whitespace-nowrap">Upload Document</span>
                          <input
                            type="file"
                            accept=".pdf, .doc, .docx, .ppt, .pptx"
                            className="hidden"
                            onChange={handleFileChange}
                          />
                        </>
                      )}
                    </label>

                    

                     <button
                      type="button"
                      onClick={() => setIsTemplateModalOpen(true)}
                      className={`cursor-pointer flex items-center gap-1 min-[380px]:gap-2 text-sm min-[380px]:text-base font-medium text-blue-600 hover:text-blue-700 min-w-0 ${!authToken ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                      disabled={!authToken}
                    >
                      <FaFileAlt className="text-sm min-[380px]:text-lg flex-shrink-0" />
                      <span className="text-sm min-[380px]:text-base truncate max-w-[140px]">
                        {selectedTemplate || "Select Template"}
                      </span>
                       <span className="ml-1 px-1.5 py-0.5 text-[10px] font-semibold uppercase rounded bg-yellow-400 text-black">
                      Beta
                    </span>
                    </button> 
    
                    {/* Images toggle */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <span className="text-sm min-[380px]:text-base font-medium text-gray-600">
                        Images
                      </span>
                      <button
                        type="button"
                        onClick={() => dispatch(setPptIncludeImages(!pptIncludeImages))}
                        className="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none"
                        style={{
                          backgroundColor: pptIncludeImages
                            ? Theme.colors.primary
                            : Theme.colors.stroke.weak,
                        }}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                            pptIncludeImages ? "translate-x-5" : "translate-x-1"
                          }`}
                        />
                      </button>
                    </div>
                  </div>
    
                  <div
                    className="text-sm font-medium text-center min-[380px]:text-left min-[380px]:self-auto"
                    style={{
                      color:
                        !file && pptGenerateInput.length < 100
                          ? "red"
                          : Theme.colors.text.strong,
                    }}
                  >
                    {pptGenerateInput.length}
                  </div>
                </div>
              </div>
            </div>
    
            {/* Dropdowns */}
            <div className="w-[92%] lg:w-2/3 mt-3 md:mt-4 lg:mt-6 mb-3 md:mb-4">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-3 md:gap-4">
                {[
                  {
                    label: "Slide Count",
                    value: pptSlideCount,
                    setter: setPptSlideCount,
                  },
                  {
                    label: "Target Language",
                    value: pptTargetLanguage,
                    setter: setPptTargetLanguage,
                  },
                  {
                    label: "Presentation Tone",
                    value: pptPresentationTone,
                    setter: setPptPresentationTone,
                  },
                  {
                    label: "Target Audience",
                    value: pptTargetAudience,
                    setter: setPptTargetAudience,
                  },
                ].map((item, idx) => {
                  const getDispatchAction = (label: string) => {
                    switch (label) {
                      case "Slide Count": return setPptSlideCount;
                      case "Target Language": return setPptTargetLanguage;
                      case "Presentation Tone": return setPptPresentationTone;
                      case "Target Audience": return setPptTargetAudience;
                      default: return setPptSlideCount;
                    }
                  };
                  
                  return (
                    <div
                      key={idx}
                      className="relative z-10 p-4 rounded-2xl border shadow-sm hover:shadow-md transition bg-gray-50"
                      style={{
                        borderColor: Theme.colors.stroke.weak,
                        backgroundColor: "#f9fafb",
                      }}
                    >
                      <label className="block text-sm font-medium mb-2 text-gray-600">
                        {item.label}
                      </label>
      
                      <select
                        value={item.value}
                        onChange={(e) => dispatch(getDispatchAction(item.label)(e.target.value))}
                        className={`w-full p-2 rounded-xl focus:ring-2 focus:ring-blue-500 border border-gray-200 text-gray-800 ${templateData.currentTemplateId != '' ? "opacity-50 cursor-not-allowed" : ""}`}
                        disabled={templateData.currentTemplateId != ''}
                      >
                      {item.label === "Slide Count" ? (
                        <>
                          <option value="Auto">Auto</option>
                          <option value="Less than 5 slides">Less than 5 slides</option>
                          <option value="5 to 10 slides">5 to 10 slides</option>
                          <option value="10 to 15 slides">10 to 15 slides</option>
                          <option value="15 to 20+ slides">15 to 20+ slides</option>
                        </>
                      ) : item.label === "Target Language" ? (
                        <>
                          <option value="Auto">Auto</option>
                          {supportedLanguages.map((lang) => (
                            <option key={lang} value={lang}>
                              {lang}
                            </option>
                          ))}
                        </>
                      ) : item.label === "Presentation Tone" ? (
                        <>
                          <option value="Auto">Auto</option>
                          <option value="Professional">Professional</option>
                          <option value="Casual">Casual</option>
                          <option value="Formal">Formal</option>
                          <option value="Conversational">Conversational</option>
                          <option value="Technical">Technical</option>
                          <option value="Persuasive">Persuasive</option>
                        </>
                      ) : (
                        <>
                          <option value="Auto">Auto</option>
                          <option value="Business professionals">
                            Business professionals
                          </option>
                          <option value="Technical experts">
                            Technical experts
                          </option>
                          <option value="General audience">General audience</option>
                          <option value="Executives">Executives</option>
                          <option value="Investors">Investors</option>
                          <option value="Clients">Clients</option>
                          <option value="Students">Students</option>
                        </>
                      )}
                      </select>
                    </div>
                  );
                })}
              </div>
            </div>
    
            {/* Submit button */}
            <div
              className="flex justify-center mt-3 md:mt-4 lg:mt-6 xl:mt-8 2xl:mt-12 relative"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => {
                setTimeout(() => setIsHovered(false), 3000);
              }}
            >
              <button
                id="generate-presentation"
                className={`h-[2.8rem] md:h-[3.1rem] px-8 md:px-16 py-3 md:py-4 rounded-full font-semibold text-sm md:text-base 
      active:scale-95 transition transform duration-300 
      flex items-center justify-center ${
        (!file && !pptGenerateInput) ||
        (!file && pptGenerateInput && pptGenerateInput.length < 100) ||
        pdfUploading
          ? "cursor-not-allowed"
          : "hover:opacity-90"
      }`}
                style={{
                  backgroundColor:
                    (!file && !pptGenerateInput) ||
                    (!file && pptGenerateInput && pptGenerateInput.length < 100) ||
                    pdfUploading || (creditsLoading || (credits ?? 0) < MIN_PRESENTATION)
                      ? Theme.colors.stroke.strong
                      : Theme.colors.primary,
                  color: "#FFFFFF",
                  cursor:
                    (!file && !pptGenerateInput) ||
                    pdfUploading ||
                    (creditsLoading || (credits ?? 0) < MIN_PRESENTATION) ||
                    (!file && pptGenerateInput && pptGenerateInput.length < 100)
                      ? "not-allowed"
                      : "pointer",
                }}
                onClick={() => {
                  // Check if user is authenticated
                  if (!authToken) {
                    // User is not logged in, store the input data in sessionStorage
                    if (pptGenerateInput) {
                      sessionStorage.setItem("pptPendingGenerateInput", pptGenerateInput);
                      console.log("Stored input in sessionStorage:", pptGenerateInput);
                    }
    
                    if (file && pdfLink) {
                      sessionStorage.setItem("pendingPdfLink", pdfLink);
                      sessionStorage.setItem("pendingFileName", file.name);
                      sessionStorage.setItem("pendingFileType", file.type);
                      console.log("Stored file info in sessionStorage:", {
                        pdfLink,
                        fileName: file.name,
                        fileType: file.type,
                      });
                    }
    
                    // Store presentation options in sessionStorage
                    sessionStorage.setItem(
                      "pptPendingWordLength",
                      pptSlideCount
                    );
                    sessionStorage.setItem(
                      "pptPendingIncludeImages",
                      pptIncludeImages.toString()
                    );
                    sessionStorage.setItem("pptPendingTargetLanguage", pptTargetLanguage);
                    sessionStorage.setItem(
                      "pptPendingPresentationTone",
                      pptPresentationTone
                    );
                    sessionStorage.setItem("pptPendingTargetAudience", pptTargetAudience);
    
                    // Store new inner modal presentation options
                    sessionStorage.setItem(
                      "pptPendingReferenceWebUrl",
                      pptReferenceWebUrl
                    );
                    sessionStorage.setItem(
                      "pptPendingIncludeWebSearch",
                      includeWebSearch.toString()
                    );
                    // sessionStorage.setItem("pptPendingTechnicalDepth", pptTechnicalDepth);
                    sessionStorage.setItem(
                      "pptPendingIncludeCitations",
                      pptIncludeCitations.toString()
                    );
    
                    console.log("Stored presentation options in sessionStorage", {
                      pptIncludeImages,
                      pptSlideCount,
                      pptTargetLanguage,
                      pptPresentationTone,
                      pptTargetAudience,
                      pptReferenceWebUrl,
                      includeWebSearch,
                      pptTechnicalDepth,
                      pptIncludeCitations,
                    });
    
                    // Set flag to auto-submit after authentication
                    sessionStorage.setItem("autoSubmitAfterAuth", "true");
                    sessionStorage.setItem("autoOpenModalAfterAuth", "true");
                    console.log(
                      "Auth flow initiated, data stored in sessionStorage"
                    );
    
                    // Redirect directly to auth page without toast
                    window.location.href = "/auth";
                    return;
                  }
    
                  // Proceed with normal flow if authenticated
                  setIsRefineModalOpen(true);
                  generateOutline();
                 
                }}
                disabled={
                  (!file && !pptGenerateInput) ||
                  (!file && pptGenerateInput && pptGenerateInput.length < 100) ||
                  pdfUploading ||
                  (creditsLoading || (credits ?? 0) < MIN_PRESENTATION)
                }
              >
                Submit
              </button>
    
               {isHovered && (
            <>
              {!file && pptGenerateInput.length < 100 ? (
                <div
                  className="absolute top-full mt-2 w-[14rem] p-2 rounded-2xl shadow-lg flex items-center justify-center opacity-100 transition-opacity duration-300"
                  style={{
                    backgroundColor: Theme.colors.stroke.weak,
                    color: Theme.colors.text.default,
                  }}
                >
                  <p
                    className="text-sm text-center"
                    style={{ color: Theme.colors.text.weak }}
                  >
                    Please provide minimum 100 characters in presentation
                    context or Upload a document.
                  </p>
                </div>
              ) : (!creditsLoading && (credits ?? 0) < MIN_PRESENTATION) ? (
                <div
                  className="absolute top-full mt-2 w-[14rem] p-2 rounded-2xl shadow-lg flex items-center justify-center opacity-100 transition-opacity duration-300"
                  style={{
                    backgroundColor: Theme.colors.stroke.weak,
                    color: Theme.colors.text.default,
                  }}
                >
                  <p
                    className="text-sm text-center"
                    style={{ color: Theme.colors.text.weak }}
                  >
                    You don't have enough credits to generate. 
                    <button
                      onClick={() => {
                        openPricing('selectpresentation')
                      }}
                      className="ml-2 px-2 py-1 bg-blue-600 text-white rounded-md text-xs"
                    >
                      Upgrade
                    </button>
                  </p>
                </div>
              ) : null}
            </>
          )}
              
              
            </div>
          </div>
    

      {/* Pricing Modal */}
      {/* Pricing modal removed - users will be redirected to the /pricing page in a new tab when upgrade is needed. */}

      {isDiscountModalOpen && userPlan === "free" && (
        <OfferModalNew
          open={isDiscountModalOpen}
          onClose={async () => {
            setIsDiscountModalOpne(false);
            setOfferGeneratedData(false);
            dispatch(setIsDiscounted(true));
          }}
          handleopenPricingModal={() => {
            setIsDiscountModalOpne(false);
            openPricing('offer')
          }}
          paymentGatewayRef={paymentGatewayRef}
          documentId={generatedDocumentIDoutline}
          userPlan={userPlan}
          exportPaid={false}
          orgId={orgId!}
          monthlyPlanId={monthlyPlanId}
          authToken={authToken!}
          userEmail={sessionStorage.getItem('userEmail') ?? undefined}
          handleButtonClick={ handleButtonClick}
          isGeneratedData={offerGeneratedData}

        />
      )}

      {/* {isPricingModalGeneratePresentationOpen && userPlan === "free" ? (
        <PricingModalGeneratePresentation
          closeModal={() => {
            setIsPricingModalGeneratePresentationOpen(false);
            // Show discount modal after closing pricing modal for the first time
            if (!isDiscounted) {
              setIsDiscountModalOpne(true);
            }
          }}
          heading={pricingModalHeading}
          subscriptionId={subId}
          monthlyPlanAmount={monthlyPlanAmount}
          yearlyPlanAmount={yearlyPlanAmount}
          currency={currency}
          monthlyPlanId={monthlyPlanId!}
          yearlyPlanId={yearlyPlanId!}
          authToken={authToken!}
          orgId={orgId!}
        />
      ) : (
        <></>
      )} */}

      <PaymentGateway
        productinfo="Presentation Export"
        onSuccess={() => {
          console.log("Payment successful");
        }}
        onFailure={() => {
          console.log("Payment failed");
        }}
        onDismiss={() => {
          console.log("Payment dismissed");
        }}
        formId={documentID || ""}
        authToken={authToken!}
        isDiscounted={isDiscounted}
        discountedAmount={(() => {
          const pricing = getProPricing(currency === "INR" ? "INR" : "USD");
          return pricing.monthlydiscounted;
        })()}
        originalAmount={(() => {
          const pricing = getProPricing(currency === "INR" ? "INR" : "USD");
          return pricing.monthly;
        })()}
        ref={paymentGatewayRef}
      />

      {/* Refine Modal */}
      {isRefineModalOpen && (
        <div
          className="fixed inset-0 z-30 flex justify-center items-center"
          style={{ backgroundColor: "rgba(23, 25, 26, 0.3)" }}
        >
          <div
            className="relative w-[90%] sm:w-[80%] h-[90%] max-w-6xl bg-white rounded-2xl shadow-xl p-2 xs:p-6 flex flex-col"
            style={{ backgroundColor: Theme.colors.background }}
          >
            {/* Close Button */}
            <button
              title="CloseModal"
              onClick={handleCloseModal}
              className="absolute top-4 right-4 p-2 bg-gray-200 rounded-full z-10"
            >
              <FaTimes style={{ color: Theme.colors.text.weak }} />
            </button>

            {/* Header with Tabs and Generate Button */}
            <div className="flex w-full items-center  border-b border-gray-300 mb-4">
              {/* Tabs Container */}
               {!isOutlineReviewed && (
                     <button
                onClick={() => setActiveTab("options")}
              className={`py-2 px-4 font-semibold transition-all ${
              activeTab === "options"
                ? "border-b-4 border-blue-600 text-blue-600"
                : "text-gray-500 hover:text-blue-600"
                 }`}
              >
              Presentation Options
            </button>
              )}

              { isOutlineReviewed && (
                  <div className="flex items-center">
                <button
                   onClick={() => {
                    if(isOutlineReviewed){
                      setActiveTab("outline");
                    }
                    else{
                      toast.info("Please click the Review outline first.", {
                        position: "top-center",
                        autoClose: 3000,
                      });
                    }
                  }}
                  className={`py-2 px-4 font-semibold transition-all ${
                    activeTab === "outline"
                      ? "border-b-4 border-blue-600 text-blue-600"
                      : "text-gray-500 hover:text-blue-600"
                  }`}
                >
                  Presentation Outline
                </button>
               
              </div>
              )}
              
            </div>

            <div className="w-full h-full overflow-y-auto scrollbar-none mt-2">
              {activeTab === "options" ? 
              
              (
                <>
                  <div className="flex flex-col overflow-y-auto pr-2 max-h-[70vh] ">
                    {/* Scrollable Form Content */}
                    <div className="flex-1 overflow-y-auto space-y-6 px-1 ">
                      {/* Reference Web URL + Language + Web Search Side-by-Side on lg */}
                      <div className="flex flex-col lg:flex-row gap-6">
                        {/* Reference Web URL */}
                        <div className="flex-1 space-y-2">
                          <label
                            className="font-semibold flex items-center gap-2"
                            style={{ color: Theme.colors.text.strong }}
                          >
                            Reference Web URL (optional)
                            <span
                              className="cursor-pointer relative"
                              style={{ color: Theme.colors.primary }}
                              onMouseEnter={() => {
                                setShowTooltip3(true);
                              }}
                              onMouseLeave={() => {
                                setShowTooltip3(false);
                              }}
                            >
                              <FaInfoCircle className="text-base" />
                              {showTooltip3 && (
                                <div
                                  className="absolute text-left top-[7%] left-[90%] w-72 p-3 text-xs rounded-lg shadow-lg transform -translate-x-1/2 transition-opacity duration-300 opacity-100 z-50"
                                  style={{
                                    backgroundColor: Theme.colors.grounding,
                                    color: Theme.colors.background,
                                    zIndex: 9999,
                                  }}
                                >
                                  <p className="font-semibold">
                                    Why add a rexference URL?
                                  </p>
                                  <p>
                                    Provide a web URL from which you would like
                                    us to include information for the
                                    presentation.
                                  </p>
                                </div>
                              )}
                            </span>
                          </label>

                          <input
                            type="text"
                            value={websiteUrl}
                            onChange={(e) => {
                              const updatedValue = e.target.value;
                              if (updatedValue === "") {
                                setWebsiteUrl("");
                                setIsValidLink(true);
                                return;
                              }
                              setWebsiteUrl(updatedValue);
                              const urlRegex =
                                /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
                              setIsValidLink(urlRegex.test(updatedValue));
                            }}
                            onFocus={() => {
                              if (!websiteUrl) setWebsiteUrl("https://");
                            }}
                            className={`w-full p-2 border rounded-lg shadow-sm outline-none focus:ring-2 ${
                              websiteUrl.length > 0 && !isValidLink
                                ? "border-red-500 focus:ring-red-500"
                                : "border-gray-300 focus:ring-[#3667B2]"
                            }`}
                            placeholder="Enter website URL"
                          />
                          {websiteUrl.length > 0 && !isValidLink && (
                            <p className="text-red-500 text-sm">
                              Please enter a valid website link.
                            </p>
                          )}
                        </div>

                        {/* Language and Web Search Container */}
                        <div className="flex-1 space-y-2">
                          {/* Language and Web Search - Side by side on lg, stacked on smaller screens */}
                          <div className="flex flex-col lg:flex-row lg:gap-8 space-y-2 lg:space-y-0">
                            {/* Language */}
                            {/* <div className="flex-1 space-y-2">
                              <label className="font-semibold flex items-center gap-2">
                                Language (optional)
                                <span className="cursor-pointer text-primary">
                                  <FaInfoCircle
                                    style={{
                                      color: Theme.colors.primary,
                                    }}
                                  />
                                </span>
                              </label>
                              <select
                                title="Language"
                                value={language}
                                onChange={(e) => setLanguage(e.target.value)}
                                className="w-full p-2 border rounded-lg shadow-sm focus:ring-2 focus:outline-none border-gray-300 focus:ring-[#3667B2]"
                              >
                                <option value="">Select a language</option>
                                {supportedLanguages.map((lang) => (
                                  <option key={lang} value={lang}>
                                    {lang}
                                  </option>
                                ))}
                              </select>
                              {language &&
                                !supportedLanguages.includes(language) && (
                                  <p className="text-red-500 text-sm">
                                    Unsupported language selected.
                                  </p>
                                )}
                            </div> */}

                            {/* Include Web Search Toggle */}
                            <div className="flex-1 space-y-2 lg:max-w-[200px]">
                              <label className="font-semibold flex items-center gap-2">
                                Include Web Search
                                <span
                                  className="cursor-pointer relative"
                                  style={{ color: Theme.colors.primary }}
                                  onMouseEnter={() => {
                                    setShowTooltip5(true);
                                  }}
                                  onMouseLeave={() => {
                                    setShowTooltip5(false);
                                  }}
                                >
                                  <FaInfoCircle className="text-base" />
                                  {showTooltip5 && (
                                    <div
                                      className="absolute text-left top-[7%]  right-[5%] w-72 p-3 text-xs rounded-lg shadow-lg transform -translate-x-1/2 transition-opacity duration-300 opacity-100 z-50"
                                      style={{
                                        backgroundColor: Theme.colors.grounding,
                                        color: Theme.colors.background,
                                        zIndex: 9999
                                      }}
                                    >
                                      <p className="font-semibold">What is Include Web Search?</p>
                                      <p>
                                      Enable to include relevant web search results on your presentation topic in the generated content.
                                      </p>
                                    </div>
                                  )}
                                </span>
                              </label>
                              <div className="flex items-center">
                                <button
                                  type="button"
                                  onClick={() =>
                                    setIncludeWebSearch(!includeWebSearch)
                                  }
                                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#3667B2] focus:ring-offset-2 ${
                                    includeWebSearch
                                      ? "bg-[#3667B2]"
                                      : "bg-gray-200"
                                  }`}
                                >
                                  <span
                                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                                      includeWebSearch
                                        ? "translate-x-6"
                                        : "translate-x-1"
                                    }`}
                                  />
                                </button>
                                <span className="ml-3 text-sm text-gray-600">
                                  {includeWebSearch ? "On" : "Off"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-6">
                        {/* Branding Colors */}
                        <div>
                          <div className="flex items-center relative">
                            <label
                              className="font-semibold"
                              style={{ color: Theme.colors.text.strong }}
                            >
                              Branding Colors
                            </label>
                            <div
                              className="relative flex items-center ml-2"
                              onMouseEnter={() => setShowTooltip4(true)}
                              onMouseLeave={() => setShowTooltip4(false)}
                            >
                              <FaInfoCircle
                                className="cursor-pointer"
                                style={{ color: Theme.colors.primary }}
                              />
                              {showTooltip4 && (
                                <div
                                  className="hidden lg:absolute lg:block lg:text-left lg:left-1/2 lg:bottom-8 lg:w-72 lg:p-3 text-xs rounded-lg shadow-lg lg:transform lg:-translate-x-1/2 transition-opacity duration-300 lg:opacity-100"
                                  style={{
                                    backgroundColor: Theme.colors.grounding,
                                    color: Theme.colors.background,
                                  }}
                                >
                                  <p className="font-semibold">
                                    Branding Colors
                                  </p>
                                  <p>
                                    These are the colors that will be used in
                                    your presentation. If you've uploaded a
                                    logo, the colors have been extracted from
                                    it.
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="flex justify-between items-center gap-2 lg:gap-0 mt-4 w-full">
                            <div
                              className="flex w-2/3 h-10 rounded-lg overflow-hidden border-2 shadow-md"
                              style={{
                                borderColor: Theme.colors.stroke.weak,
                              }}
                            >
                              {isLoading ? (
                                <p
                                  className="flex items-center justify-center w-full"
                                  style={{ color: Theme.colors.text.weak }}
                                >
                                  Loading colors...
                                </p>
                              ) : (
                                brandingColors?.map((color, index) => (
                                  <div
                                    key={index}
                                    className="h-full flex-1"
                                    style={{ backgroundColor: color }}
                                  />
                                ))
                              )}
                            </div>

                            <button
                              className={`lg:h-[2.5rem] text-xs font-medium px-4 py-2 rounded-md active:scale-95 transition transform duration-300 ${
                                isLoading ? "opacity-50 cursor-not-allowed" : ""
                              }`}
                              style={{
                                backgroundColor: Theme.colors.background,
                                color: Theme.colors.primary,
                                border: `1px solid ${Theme.colors.primary}`,
                              }}
                              disabled={isLoading}
                              onClick={() => !isLoading && setIsModalOpen(true)}
                            >
                              Change branding colors
                            </button>
                          </div>
                        </div>
                        {/* Theme Selection */}
                        <div
                          className="flex flex-col space-y-3 p-4 rounded-lg shadow-sm"
                          style={{
                            backgroundColor: Theme.colors.stroke.weak,
                          }}
                        >
                          {/* Label with Relaxed Hover Tooltip */}
                          <div className="relative w-max">
                            <label
                              className="font-semibold flex items-center gap-2"
                              style={{ color: Theme.colors.text.strong }}
                            >
                              Choose a Theme
                              <span
                                className="cursor-pointer relative"
                                onMouseEnter={() => setShowThemeTooltip(true)}
                                onMouseLeave={() => setShowThemeTooltip(false)}
                                style={{ color: Theme.colors.primary }}
                              >
                                <FaInfoCircle className="text-base" />
                                {showThemeTooltip && (
                                  <div
                                    className="hidden lg:absolute lg:block text-left left-1/2 bottom-8 w-72 p-3 text-xs rounded-lg shadow-lg opacity-100 transform -translate-x-1/2 transition-opacity duration-300"
                                    style={{
                                      backgroundColor: Theme.colors.grounding,
                                      color: Theme.colors.background,
                                    }}
                                  >
                                    <p className="font-semibold">
                                      How do themes work?
                                    </p>
                                    <p>
                                      Choose how your slides will appear. All
                                      themes incorporate your brand colors for
                                      text and accents.
                                    </p>
                                  </div>
                                )}
                              </span>
                            </label>
                          </div>

                          <div className="flex justify-between mt-2 gap-3">
                            {[
                              {
                                name: "Light",
                                backgroundColor: Theme.colors.background,
                                textColor: Theme.colors.text.default,
                                borderColor: Theme.colors.stroke.weak,
                                tooltip:
                                  "White background with brand colors for text & accents.",
                              },
                              {
                                name: "Dark",
                                backgroundColor: Theme.colors.grounding,
                                textColor: Theme.colors.background,
                                borderColor: Theme.colors.stroke.strong,
                                tooltip:
                                  "Black background with brand colors for text & accents.",
                              },
                              {
                                name: "Branded",
                                backgroundColor: primaryColor,
                                textColor: textColor,
                                borderColor: primaryColor,
                                tooltip:
                                  "Background in your brand’s main color.",
                              },
                            ].map(
                              ({
                                name,
                                backgroundColor,
                                textColor,
                                borderColor,
                                tooltip,
                              }) => (
                                <div
                                  key={name}
                                  className="relative w-1/3"
                                  onMouseEnter={() => setHoveredTheme(name)}
                                  onMouseLeave={() => setHoveredTheme(null)}
                                >
                                  <button
                                    onClick={() => setTheme(name)}
                                    className={`w-full py-2 rounded-lg border-2 font-semibold text-center transition-all ${
                                      theme === name
                                        ? "scale-105 shadow-md"
                                        : ""
                                    } hover:scale-105 hover:shadow-lg`}
                                    style={{
                                      backgroundColor,
                                      color: textColor,
                                      borderColor:
                                        theme === name
                                          ? Theme.colors.primary
                                          : borderColor,
                                    }}
                                  >
                                    {name}
                                  </button>

                                  {/* Tooltip for Individual Themes */}
                                  {hoveredTheme === name && (
                                    <div
                                      className="hidden lg:absolute lg:bottom-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mb-2 w-max rounded px-3 py-2 shadow-lg opacity-100 transition-opacity duration-200 text-xs"
                                      style={{
                                        backgroundColor: Theme.colors.grounding,
                                        color: Theme.colors.background,
                                      }}
                                    >
                                      {tooltip}
                                    </div>
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </div>

                        {/* Creativity Slider */}
                        <div
                          className="flex flex-col space-y-3 p-4 rounded-lg shadow-sm"
                          style={{
                            backgroundColor: Theme.colors.stroke.weak,
                          }}
                        >
                          {/* Label, Info Icon, and Value Display */}
                          <div className="flex justify-between gap-1 items-center">
                            <div className="relative text-sm leading-snug">
                              <span
                                className="inline-flex items-center gap-1 flex-wrap font-semibold text-base"
                                style={{ color: Theme.colors.text.strong }}
                              >
                                Adjust Creativity
                                <span
                                  className="cursor-pointer"
                                  onMouseEnter={() =>
                                    setShowCreativityTooltip(true)
                                  }
                                  onMouseLeave={() =>
                                    setShowCreativityTooltip(false)
                                  }
                                  style={{ color: Theme.colors.primary }}
                                >
                                  <FaInfoCircle className="text-base inline" />
                                  {showCreativityTooltip && (
                                    <div
                                      className="hidden lg:block absolute text-left left-1/2 bottom-8 w-72 p-3 text-xs rounded-lg shadow-lg opacity-100 transform -translate-x-1/2 transition-opacity duration-300"
                                      style={{
                                        backgroundColor: Theme.colors.grounding,
                                        color: Theme.colors.background,
                                      }}
                                    >
                                      <p className="font-semibold">
                                        How does Creativity affect text?
                                      </p>
                                      <p>
                                        Adjust how creative or structured the
                                        generated text should be...
                                      </p>
                                    </div>
                                  )}
                                </span>
                              </span>
                            </div>

                            <span
                              className="font-medium"
                              style={{ color: Theme.colors.text.strong }}
                            >
                              Creativity: {creativity.toFixed(1)}
                            </span>
                          </div>

                          {/* Styled Slider */}
                          <input
                            type="range"
                            min="0"
                            max="10"
                            step="0.1"
                            value={creativity}
                            onChange={(e) => {
                              let newValue = Number(e.target.value);
                              newValue = Math.max(0, Math.min(10, newValue)); // Keep within range
                              setCreativity(newValue);
                            }}
                            className="w-full h-2 rounded-lg transition-all appearance-none "
                            style={{
                              background: `linear-gradient(to right, ${
                                Theme.colors.primary
                              } ${(creativity / 10) * 100}%, white ${
                                (creativity / 10) * 100
                              }%)`,
                              color: Theme.colors.primary,
                            }}
                          />

                          {/* Indicator Bar with Tooltips */}
                          <div
                            className="flex justify-between text-xs font-medium mt-2"
                            style={{ color: Theme.colors.text.weak }}
                          >
                            <div className="relative group">
                              <span
                                className={
                                  creativity === 0
                                    ? "font-bold text-center"
                                    : "text-center"
                                }
                                style={{
                                  color:
                                    creativity === 0
                                      ? Theme.colors.primary
                                      : undefined,
                                }}
                              >
                                Most Structured
                              </span>
                              <div
                                className="hidden lg:absolute lg:top-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mt-2 w-max text-xs rounded px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg"
                                style={{
                                  backgroundColor: Theme.colors.grounding,
                                  color: Theme.colors.background,
                                }}
                              >
                                Highly precise and factual text with minimal
                                variation.
                              </div>
                            </div>

                            <div className="relative group">
                              <span
                                className={
                                  creativity >= 4.5 && creativity <= 5.5
                                    ? "font-bold text-center"
                                    : "text-center"
                                }
                                style={{
                                  color:
                                    creativity >= 4.5 && creativity <= 5.5
                                      ? Theme.colors.primary
                                      : undefined,
                                }}
                              >
                                Balanced
                              </span>
                              <div
                                className="hidden lg:absolute lg:top-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mt-2 w-max text-xs rounded px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg"
                                style={{
                                  backgroundColor: Theme.colors.grounding,
                                  color: Theme.colors.background,
                                }}
                              >
                                A mix of structured content with slight
                                variations for engagement.
                              </div>
                            </div>

                            <div className="relative group">
                              <span
                                className={
                                  creativity === 10
                                    ? "font-bold text-center ml-2 xs:ml-0"
                                    : "text-center"
                                }
                                style={{
                                  color:
                                    creativity === 10
                                      ? Theme.colors.primary
                                      : undefined,
                                }}
                              >
                                Most Creative
                              </span>
                              <div
                                className="hidden lg:absolute lg:top-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mt-2 w-max text-xs rounded px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg"
                                style={{
                                  backgroundColor: Theme.colors.grounding,
                                  color: Theme.colors.background,
                                }}
                              >
                                Free-flowing, expressive text with maximum
                                variation.
                              </div>
                            </div>
                          </div>
                        </div>

                         <div className="space-y-2 mt-6">
                                                  <label
                                                    className="flex items-center gap-2 text-sm font-medium"
                                                    style={{ color: Theme.colors.text.weak }}
                                                  >
                                                    Technical Depth
                                                    <div className="relative group">
                                                      <FaInfoCircle
                                                        className="cursor-pointer"
                                                        style={{ color: Theme.colors.text.weak }}
                                                      />
                                                      <div className="hidden group-hover:block absolute z-10 left-full ml-2 -translate-y-1/2 w-64 p-2 text-xs rounded-lg shadow-lg bg-gray-800 text-white">
                                                        Choose how technical the content should be in
                                                        your presentation.
                                                      </div>
                                                    </div>
                                                  </label>
                                                  <select
                                                    value={technicalDepth}
                                                    onChange={(e) => dispatch(setTechnicalDepth(e.target.value))}
                                                    className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2"
                                                    style={{
                                                      backgroundColor: Theme.colors.background,
                                                      color: Theme.colors.text.strong,
                                                      borderColor: Theme.colors.stroke.weak,
                                                      outlineColor: Theme.colors.primary,
                                                    }}
                                                  >
                                                    <option value="Auto">Auto</option>
                                                    <option value="Basic">Basic</option>
                                                    <option value="Medium">Medium</option>
                                                    <option value="Advanced">Advanced</option>
                                                    <option value="Expert">Expert</option>
                                                  </select>
                                                </div>
                      </div>
                    </div>

                    <div className="flex w-full justify-center mt-4 xl:mt-12">
                      <button
                        disabled={
                          isLoading || (websiteUrl.length > 0 && !isValidLink)
                        }
                        onClick={()=>{
                          setIsOutlineReviewed(true);
                          setActiveTab("outline");
                          getWebsiteData()
                        
                        }}
                        className={`lg:w-1/2 w-[80%] py-2 rounded-lg font-semibold active:scale-95 transition transform duration-300  ${
                          isLoading || (websiteUrl.length > 0 && !isValidLink)
                            ? "cursor-not-allowed"
                            : "hover:opacity-90"
                        }`}
                        style={{
                          backgroundColor:
                            isLoading || (websiteUrl.length > 0 && !isValidLink)
                              ? Theme.colors.stroke.weak
                              : Theme.colors.primary,
                          color:
                            isLoading || (websiteUrl.length > 0 && !isValidLink)
                              ? Theme.colors.text.weak
                              : "#FFFFFF",
                        }}
                      >
                        Review Outline
                      </button>
                    </div>
                  </div>
                </>
              )
              
              :
              (
                <div className="space-y-4  pr-2 max-h-full relative">
                  {isOutlineLoading ? (
                    <div className="flex flex-col justify-center items-center py-5 relative">
                      <ul className="space-y-6 w-full">
                        {Array.from({ length: 5 }).map((_, idx) => (
                          <li key={idx} className="relative w-full">
                            <div className="border w-full border-gray-200 p-4 rounded-md shadow-sm bg-white flex flex-col gap-2 animate-pulse">
                              <div className="h-5 bg-gray-200 rounded w-2/3"></div>
                              <div className="h-4 bg-gray-100 rounded w-1/3"></div>
                            </div>
                          </li>
                        ))}
                      </ul>
                      {/* <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                  <p className="text-base">Outline Generating</p> */}
                   <div className="absolute   bottom-0 left-0 w-full bg-white border-t border-gray-200 py-3 flex justify-center">
                        <button
                          disabled={
                              isLoading || (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading || creditsLoading || ((credits ?? 0) < MIN_PRESENTATION)
                            }
                            onClick={async () => {
                              // Gate by credits only. If user has enough credits, proceed to view presentation.
                              if (creditsLoading) return; // still loading; ignore clicks

                              const available = credits ?? 0
                              if (available >= MIN_PRESENTATION) {
                                // Proceed to generate/view presentation
                                dispatch(resetToAuto());
                                handleButtonClick();
                                return;
                              }

                              // Insufficient credits -> open canonical pricing page
                              openPricing('selectpresentation_credit')
                              setOfferGeneratedData(false);
                              return;
                            }}
                          className={`lg:w-1/2 w-[80%] py-2 rounded-lg font-semibold active:scale-95 transition transform duration-300 ${
                            isLoading || (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                              ? "cursor-not-allowed"
                              : "hover:opacity-90"
                          }`}
                          style={{
                            backgroundColor:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                                ? Theme.colors.stroke.weak
                                : Theme.colors.primary,
                            color:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                                ? Theme.colors.text.weak
                                : "#FFFFFF",
                          }}
                        >
                          Generate Presentation
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col max-h-[70vh]">
                      <div className="flex-1 overflow-y-auto pr-1">
                        <ul className="space-y-6">
                          {outline?.map((slide: any, idx: number) => (
                            <React.Fragment key={slide.outlineID}>
                              <li className="relative group">
                                <div className="relative border border-gray-200 p-4 rounded-md shadow-sm bg-white flex flex-col gap-2 transition-all duration-200 hover:shadow-md hover:border-gray-300">
                                  {editingIndex !== idx && (
                                    <div className="absolute top-2 right-2 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                      <button
                                        onClick={() => {
                                          setEditingIndex(idx);
                                          setEditedOutline({
                                            title: slide.title,
                                            keywords: slide.keywords || "",
                                            slideInput: slide.slideInput || "",
                                          });
                                        }}
                                        title="Edit"
                                        className="transition-all duration-200 hover:scale-110"
                                      >
                                        <FaEdit
                                          className="text-gray-500 hover:text-blue-600 transition-colors duration-200"
                                          style={{ fontSize: "1rem" }}
                                        />
                                      </button>
                                      <button
                                        onClick={() => handleDeleteOutline(idx)}
                                        title="Delete"
                                        className="transition-all duration-200 hover:scale-110"
                                      >
                                        <FaTrash
                                          className="text-gray-500 hover:text-red-500 transition-colors duration-200"
                                          style={{ fontSize: "1rem" }}
                                        />
                                      </button>
                                    </div>
                                  )}

                                  {editingIndex === idx ? (
                                    <div className="flex flex-col gap-3">
                                      <input
                                        value={editedOutline.title}
                                        onChange={(e) =>
                                          setEditedOutline({
                                            ...editedOutline,
                                            title: e.target.value,
                                          })
                                        }
                                        placeholder="Title"
                                        className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                      />
                                      <input
                                        value={editedOutline.keywords}
                                        onChange={(e) =>
                                          setEditedOutline({
                                            ...editedOutline,
                                            keywords: e.target.value,
                                          })
                                        }
                                        placeholder="Keywords"
                                        className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                      />
                                      <input
                                        value={editedOutline.slideInput}
                                        onChange={(e) =>
                                          setEditedOutline({
                                            ...editedOutline,
                                            slideInput: e.target.value,
                                          })
                                        }
                                        placeholder="SlideInput"
                                        className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                      />
                                      <div className="flex gap-3">
                                        <button
                                          className="text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700 transition-all duration-200"
                                          onClick={async () => {
                                            if (
                                              editedOutline.title ===
                                                slide.title &&
                                              editedOutline.keywords ===
                                                (slide.keywords || "") &&
                                              editedOutline.slideInput ===
                                                (slide.slideInput || "")
                                            ) {
                                              setEditingIndex(null);
                                              return;
                                            }

                                            const updated = [...outline];
                                            updated[idx] = {
                                              ...slide,
                                              title: editedOutline.title,
                                              keywords: editedOutline.keywords,
                                              slideInput: editedOutline.slideInput,
                                            };
                                            setOutline(updated);
                                            setEditingIndex(null);

                                            try {
                                              await axios.post(
                                                `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/update`,
                                                {
                                                  documentId:
                                                    generatedDocumentIDoutline,
                                                  blockItem: {
                                                    outlineID: slide.outlineID,
                                                    title: editedOutline.title,
                                                    keywords: editedOutline.keywords,
                                                    slideInput: editedOutline.slideInput,
                                                  },
                                                },
                                                {
                                                  headers: {
                                                    Authorization: `Bearer ${authToken}`,
                                                  },
                                                }
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Update failed",
                                                error
                                              );
                                            }
                                          }}
                                        >
                                          Save
                                        </button>
                                        <button
                                          className="text-gray-700 border border-gray-300 px-4 py-2 rounded-md hover:bg-gray-100 transition-all duration-200"
                                          onClick={() => setEditingIndex(null)}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <h3 className="text-lg font-semibold text-gray-800">
                                        {slide.title}
                                      </h3>
                                      {slide.keywords && (
                                        <p className="text-sm text-gray-600">
                                          <span className="font-medium">
                                            Keywords:
                                          </span>{" "}
                                          {slide.keywords}
                                        </p>
                                      )}
                                      {slide.slideInput && (
                                        <p className="text-sm text-gray-600">
                                          <span className="font-medium">
                                            SlideInput:
                                          </span>{" "}
                                          {slide.slideInput}
                                        </p>
                                      )}
                                    </>
                                  )}
                                </div>

                                {idx > -1 && (
                                  <div className="mt-4 flex items-center justify-center space-x-4 relative hidden group-hover:flex">
                                    <div className="flex-grow h-px bg-gray-300"></div>

                                    <div className="relative">
                                      <button
                                        className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-400 bg-white text-gray-500 hover:bg-gray-100 hover:border-gray-500 transition-all duration-200 hover:scale-110"
                                        onClick={() => setInputIndex(idx)}
                                        title="Add new section"
                                      >
                                        +
                                      </button>
                                    </div>

                                    <div className="flex-grow h-px bg-gray-300"></div>
                                  </div>
                                )}
                              </li>

                              {inputIndex === idx && (
                                <div className="border border-gray-200 p-4 rounded-md shadow-sm bg-white flex flex-col gap-3 -mt-2">
                                  <input
                                    type="text"
                                    value={newOutline}
                                    onChange={(e) =>
                                      setNewOutline(e.target.value)
                                    }
                                    placeholder="Title"
                                    className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                    autoFocus
                                  />

                                  <div className="flex gap-3">
                                    <button
                                      className="text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                      onClick={() => handleAddOutline(idx)}
                                      disabled={!newOutline.trim()}
                                    >
                                      {newOutlineLoading ? (
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                      ) : (
                                        "Add"
                                      )}
                                    </button>
                                    <button
                                      className="text-gray-700 border border-gray-300 px-4 py-2 rounded-md hover:bg-gray-100 transition-all duration-200"
                                      onClick={() => {
                                        setInputIndex(null);
                                        setNewOutline("");
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              )}
                            </React.Fragment>
                          ))}
                        </ul>
                      </div>
                      <div className="flex w-full justify-center mt-4">
                        <button
                          disabled={
                            isLoading || (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading || checkingTrialEligibility
                          }
                          onClick={async () => {
                            // Check if user is eligible for trial (odd orgId AND hasn't used trial)
                            const orgIdNumber = parseInt(orgId?.replace(/\D/g, '') || '0', 10);
                            const isOddOrgId = orgIdNumber % 2 !== 0;
                            
                            // If odd orgId and free user, check trial eligibility first
                            if (isOddOrgId && userPlan === "free" && eligibleForGeneration) {
                              setCheckingTrialEligibility(true);
                              try {
                                const response = await axios.get(
                                  `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
                                  {
                                    headers: { Authorization: `Bearer ${authToken}` },
                                  }
                                );
                                
                                const currentHasUsedTrial = response.data.hasUsedTrial || false;
                                setHasUsedTrial(currentHasUsedTrial);
                                
                                console.log('🎯 Generate Button Click - Trial Check:', {
                                  orgId,
                                  isOddOrgId,
                                  hasUsedTrial: currentHasUsedTrial,
                                  isEligibleForTrial: !currentHasUsedTrial,
                                  userPlan,
                                  eligibleForGeneration
                                });
                                
                                // Only show pricing page in a new tab if trial NOT used
                                if (!currentHasUsedTrial) {
                                  openPricing('selectpresentation_trial')
                                  setCheckingTrialEligibility(false);
                                  return;
                                }
                                // If trial already used, redirect to pricing/upgrade page
                                {
                                  openPricing('selectpresentation_trial_used')
                                  setCheckingTrialEligibility(false);
                                  return;
                                }
                              } catch (error) {
                                console.error('Error checking trial eligibility:', error);
                                setCheckingTrialEligibility(false);
                              }
                            }
                            
                            // Pre-flight credit check for full presentation generation.
                            // If credits are loading, ask the user to wait. If insufficient,
                            // open the canonical pricing page and DO NOT proceed with generation.
                            if (creditsLoading) {
                              toast.info("Checking credits, please wait...", {
                                position: "top-right",
                                autoClose: 2000,
                              });
                              setCheckingTrialEligibility(false);
                              return;
                            }

                            if (!ensureCredits(MIN_PRESENTATION)) {
                              openPricing('selectpresentation')
                              setOfferGeneratedData(true);
                              setCheckingTrialEligibility(false);
                              return;
                            }
                            
                            dispatch(resetToAuto());
                            handleButtonClick();
                          }}
                          className={`lg:w-1/2 w-[80%] py-2 rounded-lg font-semibold active:scale-95 transition transform duration-300 ${
                            isLoading || (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                              ? "cursor-not-allowed"
                              : "hover:opacity-90"
                          }`}
                          style={{
                            backgroundColor:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                                ? Theme.colors.stroke.weak
                                : Theme.colors.primary,
                            color:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                                ? Theme.colors.text.weak
                                : "#FFFFFF",
                          }}
                        >
                          Generate Presentation
                        </button>
                      </div>
                    </div>
                  )
                  }
                </div>
              ) 
              }
            </div>
          </div>
        </div>
      )}
      {/* Color Selection Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-[40]">
          <div
            className="p-6 rounded-2xl shadow-lg w-[90%] max-w-md relative"
            style={{ backgroundColor: Theme.colors.background }}
          >
            <h2
              className="text-xl font-bold mb-4 text-center"
              style={{ color: Theme.colors.text.strong }}
            >
              Select Branding Colors
            </h2>

            <div className="space-y-4">
              {/* Primary Color */}
              <div className="grid grid-cols-3 items-center gap-2">
                <label
                  className="font-semibold"
                  style={{ color: Theme.colors.text.weak }}
                >
                  Primary Color:
                </label>
                <input
                  type="text"
                  value={primaryColor}
                  onChange={(e) => setPrimaryColor(e.target.value)}
                  className="w-24 p-2 border rounded-lg text-center shadow-sm focus:ring-2 outline-none"
                  style={{
                    borderColor: Theme.colors.stroke.weak,
                    color: Theme.colors.text.strong,
                    fontFamily: Theme.font.family,
                    backgroundColor: Theme.colors.background,
                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                  }}
                />
                <div className="relative w-12 h-12">
                  <input
                    type="color"
                    value={primaryColor}
                    onChange={(e) => setPrimaryColor(e.target.value)}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  />
                  <div
                    className="w-12 h-12 rounded-full border shadow-md cursor-pointer transition-transform hover:scale-110"
                    style={{
                      backgroundColor: primaryColor,
                      borderColor: Theme.colors.stroke.weak,
                    }}
                  />
                </div>
              </div>

              {/* Secondary Color */}
              <div className="grid grid-cols-3 items-center gap-2">
                <label
                  className="font-semibold"
                  style={{ color: Theme.colors.text.weak }}
                >
                  Secondary Color:
                </label>
                <input
                  type="text"
                  value={secondaryColor}
                  onChange={(e) => setSecondaryColor(e.target.value)}
                  className="w-24 p-2 border rounded-lg text-center shadow-sm focus:ring-2 outline-none"
                  style={{
                    borderColor: Theme.colors.stroke.weak,
                    color: Theme.colors.text.strong,
                    fontFamily: Theme.font.family,
                    backgroundColor: Theme.colors.background,
                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                  }}
                />
                <div className="relative w-12 h-12">
                  <input
                    type="color"
                    value={secondaryColor}
                    onChange={(e) => setSecondaryColor(e.target.value)}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  />
                  <div
                    className="w-12 h-12 rounded-full border shadow-md cursor-pointer transition-transform hover:scale-110"
                    style={{
                      backgroundColor: secondaryColor,
                      borderColor: Theme.colors.stroke.weak,
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Modal Buttons */}
            <div className="mt-6 flex justify-end space-x-4">
              <button
                className="px-4 py-2 rounded-lg transition-all"
                style={{
                  backgroundColor: Theme.colors.stroke.weak,
                  color: Theme.colors.text.weak,
                }}
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-lg transition-all shadow-md"
                style={{
                  backgroundColor: Theme.colors.primary,
                  color: "#FFFFFF",
                }}
                onClick={() => {
                  handleSaveColors();
                  setIsModalOpen(false);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Template Selection Modal */}
      {isTemplateModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-[40]">
          <div
            className="p-6 rounded-2xl shadow-lg w-[90%] max-w-2xl max-h-[80vh] overflow-y-auto relative"
            style={{ backgroundColor: Theme.colors.background }}
          >
            <button
              onClick={() => setIsTemplateModalOpen(false)}
              className="absolute top-4 right-4 p-2 bg-gray-200 rounded-full z-10"
            >
              <FaTimes style={{ color: Theme.colors.text.weak }} />
            </button>

            <h2
              className="text-xl font-bold mb-6 text-center"
              style={{ color: Theme.colors.text.strong }}
            >
              Select a Template
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {console.log('Templates in modal:', templates)} {/* Debug log */}
              {templates && templates.length > 0 ? (
                templates.map((template: any) => {
                  const isProcessing = template.status === "processing";
                  return (
                    <button
                      key={template.templateId}
                      onClick={() => {
                        if (isProcessing) return; // Disable click during processing
                        if (selectedTemplate === template.templateName) {
                        // Deselect → keep modal OPEN
                        setSelectedTemplate("");
                        dispatch(setCurrentTemplateId(""));
                        return;
                        }
                        setSelectedTemplate(template.templateName);
                        dispatch(setCurrentTemplateId(template.templateId));
                        setIsTemplateModalOpen(false);
                      }}
                      disabled={isProcessing}
                      className={`p-4 rounded-lg border-2 text-left transition-all hover:shadow-md ${
                        selectedTemplate === template.templateName
                          ? "border-blue-500 bg-blue-50"
                          : isProcessing
                          ? "border-orange-300 bg-orange-50 cursor-not-allowed"
                          : "border-gray-200 hover:border-gray-300"
                      }`}
                      style={{
                        fontFamily: Theme.font.family,
                        color: Theme.colors.text.strong,
                      }}
                    >
                      <div className="flex items-center gap-3">
                        <FaFileAlt
                          className="text-lg"
                          style={{ color: isProcessing ? "#f97316" : Theme.colors.primary }}
                        />
                        <div className="flex flex-col flex-1 min-w-0">
                          <span className="font-medium truncate" title={template.templateName}>
                            {template.templateName}
                          </span>
                          {isProcessing && (
                            <span className="text-xs text-orange-600 mt-1">
                              Processing... Please wait
                            </span>
                          )}
                        </div>
                       
                      </div>
                    </button>
                  );
                })
              ) : (
                <div className="col-span-2 text-center py-8">
                  <p style={{ color: Theme.colors.text.weak }}>
                    No templates available. Upload a template to get started.
                  </p>
                </div>
              )}
            </div>
            <div className="mt-6 flex justify-end">
  <label className="cursor-pointer flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-blue-600 hover:text-blue-700">
    {templateUploading ? (
      <span className="text-gray-700">Uploading...</span>
    ) : (
      <>
        <FaUpload className="text-lg" />
        <span>Upload Template</span>
      </>
    )}
    <input
      type="file"
      accept=".ppt,.pptx,.xls,.xlsx"
      className="hidden"
      onChange={handleTemplateUpload}
    />
  </label>
</div>


            {/* <div className="mt-6 flex justify-end space-x-4">
              <button
                className="px-4 py-2 rounded-lg transition-all"
                style={{
                  backgroundColor: Theme.colors.stroke.weak,
                  color: Theme.colors.text.weak,
                }}
                onClick={() => setIsTemplateModalOpen(false)}
              >
                Cancel
              </button>
            </div> */}
          </div>
        </div>
      )}

      <GuidedTour />
      <GuidedTourMobile />
    </div>
  );
};

export default SelectPresentationType;
const onOutlineSuccess = (success: boolean) => {
  if (success) {
    toast.success("Outline generated successfully!", {
      position: "top-right",
      autoClose: 3000,
    });
  } else {
    toast.error("Failed to generate outline. Please try again.", {
      position: "top-right",
      autoClose: 3000,
    });
  }
};

function setIsOutlineGenerated(arg0: boolean) {
  throw new Error("Function not implemented.");
}